import type {ReactElement} from 'react';
import type {QRSmsInput} from '@Libraries/qr-code/qr-code.types';
import {QRField} from '@Components/qr-code-generator/components/qr-field/qr-field';
import {QRPhoneNumberField} from '@Components/qr-code-generator/components/qr-phone-number-field/qr-phone-number-field';
import type {QRFormProps} from '@Components/qr-code-generator/qr-code-generator.types';

export function QRSmsForm({input, issues, onPatch}: QRFormProps<QRSmsInput>): ReactElement {
  return (
    <>
      <QRPhoneNumberField
        value={input.phoneNumber}
        issues={issues}
        onValueChange={(phoneNumber): void => {
          onPatch({phoneNumber});
        }}
      />
      <QRField
        label={window.i18next.t('pmwjs_qr_generator_sms_message_label')}
        placeholder={window.i18next.t('pmwjs_qr_generator_sms_message_placeholder')}
        value={input.message}
        isMultiline
        onValueChange={(message): void => {
          onPatch({message});
        }}
      />
    </>
  );
}
